











































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ProviderFilter from "@/components/report/filters/Providers.vue";
import StatusFilter from "@/components/report/filters/Status.vue";
import SubStatusFilter from "@/components/report/filters/SubStatus.vue";
import ApptDateFilter from "@/components/report/filters/ApptDate.vue";
import AdmissionDischargeFilter from "@/components/report/filters/AdmissionDischarge.vue";


@Component({
  components: {
    ProviderFilter,
    StatusFilter,
    SubStatusFilter,
    ApptDateFilter,
    AdmissionDischargeFilter
  },
   computed: {
   
  }
})


export default class YearlyStatusList extends Vue {
  @Prop(Array) readonly items!: Array<any>;
  @Prop(Object) readonly filter!: Object;

}
